import React, { useCallback, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { VuiButton } from '../../../../../vodea/@vodea-ui/components/VuiButton';
import clsx from 'clsx';
import { useForm } from 'react-hook-form';

interface Props {
  note: string;
  onSave: (value: string) => void;
}

const ButtonAddNote: React.FC<Props> = ({note, onSave}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    errors,
    reset,
    register,
    handleSubmit
  } = useForm({
    defaultValues: {
      note: '',
    }
  })

  const handleOnClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onSubmit = handleSubmit((data) => {
    onSave(data.note);
    reset();
    handleOnClose();
  });

  const handleOpen = useCallback(() => {
    setIsOpen(true);
    reset({ note });
  }, [note]);

  return (
    <>
      <Modal show={isOpen} onHide={handleOnClose} backdrop={'static'} centered>
        <Modal.Header closeButton>
          <Modal.Title>{note ? 'Edit Note' : 'Add Note'}</Modal.Title>
        </Modal.Header>

        <form className={'form-wrapper'} onSubmit={onSubmit}>
          <Modal.Body>
            <div
              className={clsx({
                'form-group': true,
                error: errors.note
              })}
            >
              <label className={'form-label'}>Note</label>
              <textarea name='note' rows={5} className='form-control' ref={register} />
              <label className={'label-help'}>{errors.note?.message}</label>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant={'light'} onClick={handleOnClose}>
              Cancel
            </Button>
            <VuiButton forSubmit={true} label={'Save'} loading={false} />
          </Modal.Footer>
        </form>
      </Modal>

      <div onClick={handleOpen} className='btn-chip'>{note ? 'View Note' : 'Add Note'}</div>
    </>
  );
}

export default ButtonAddNote;